module.exports = __webpack_public_path__ + "img/mozzo6.eae1842f.jpeg";